module.exports = __webpack_public_path__ + "img/jianshe.2d23388d.png";